

























































import { Component } from "vue-property-decorator";
import { GrantTypes } from "@/data/enums/tokens";
import { mixins } from "vue-class-component";
import HasValidation from "@/mixins/HasValidation";
import HashVerificationMixin from "@/mixins/hashVerificationMixin";

@Component({
  components: {
    "create-password": () =>
      import("@/components/app/global/fields/createPasswordField.vue")
  }
})
export default class ChangePasswordForm extends mixins(
  HasValidation,
  HashVerificationMixin
) {
  // Data
  public isProcessing = false;
  public form = {
    password: "",
    twoFACode: ""
  };

  // Computed

  public get isDisabled() {
    return (
      this.isProcessing ||
      this.hash.isExpiredOrInvalid ||
      !this.form.password.length ||
      (this.hash.twoFARequired && !this.form.twoFACode.length)
    );
  }

  // Life-cycle methods

  public created() {
    this.initHashVerification();
  }

  // Methods

  public async changePassword() {
    this.clearErrors();
    try {
      this.isProcessing = true;
      if (!(await this.validate())) throw this.$t("_.form_invalid");
      await this.$store.dispatch(`auth/login`, {
        context: this.context,
        payload: {
          username: this.username,
          password: this.form.password,
          reg_hash: this.reg_hash,
          grant_type: this.isAdmin
            ? GrantTypes.ADMIN_PASSWORD_RESET
            : GrantTypes.PASSWORD_RESET,
          ...(this.hash.twoFARequired
            ? {
                twofa_code: this.form.twoFACode,
                twofa_provider: this.hash.twoFAProvider
              }
            : {})
        }
      });
      this.$buefy.toast.open({
        message: this.$t("_sentence.password_changed") as string
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
